import React from "react";
import * as env from "shared/env";
import { LegacySettingsMapSearchPage } from "./legacy";
import { RefreshedSettingsMapSearchPage } from "./refreshed";

// MAX-3621: the refreshed Map settings page is gated behind the REFRESH_DESIGNS dev flag.
// When the flag is off, the legacy "Map Search" page renders unchanged.
export const SettingsMapSearchPage: React.FC<any> = (props) =>
	env.refreshDesignsDev ? (
		<RefreshedSettingsMapSearchPage {...props} />
	) : (
		<LegacySettingsMapSearchPage {...props} />
	);
